import React from "react";
import { Card, Row, Col, Typography, Button } from "antd";
import { getDaysAgo } from "../../../utils/formatters";
import { useNavigate } from "react-router-dom";
import PageRoutes from "../../../utils/routes";
const { Title, Text } = Typography;

export const JobCard = ({ job }) => {
  const navigate = useNavigate();
  const {
    firmUser: {
      firm: { companyName, imageUrl },
    },
    position: { name: positionName },
    advertStartDate,
    title,
    district,
    city,
    country,
    id,
  } = job;

  const location =
    district !== null
      ? `${district.name} / ${district.city.name}`
      : city !== null
      ? city.name
      : country.name;

  const handleGoToDetailsPage = (id) => {
    navigate(`${PageRoutes.advertDetailEmployee}/${id}`);
  };

  return (
    <Card
      styles={{
        body: {
          paddingTop: 20,
          paddingBottom: 16,
        },
      }}
      style={{
        width: "100%",
      }}>
      <Row gutter={[16, 16]} align="top">
        <Col xs={24} sm={6}>
          <img
            src={imageUrl}
            alt={companyName}
            style={{
              width: "60px",
              maxWidth: "100px",
              objectFit: "contain",
              "@media (min-width: 576px)": {
                width: "100%",
              },
            }}
          />
        </Col>
        <Col xs={24} sm={18}>
          <Row>
            <Col flex="auto">
              <Title style={{ marginBottom: 0, marginTop: 0 }} level={4}>
                {title}
              </Title>
              <Text strong>{companyName}</Text>
              <br />
              <Text>
                {location} • {positionName}
              </Text>
              <br />
              <Text type="secondary">{getDaysAgo(advertStartDate)}</Text>
            </Col>
            <Col>
              <Button
                onClick={() => handleGoToDetailsPage(id)}
                type="link"
                style={{ padding: "8px" }}>
                İncele
              </Button>
            </Col>
          </Row>
        </Col>
      </Row>
    </Card>
  );
};
